import { MultiColumnFormFields } from "@components/common/form/FormFields";
import { PeekButton, PeekDialogActions, PeekDialogContent } from "@piiqtechnologies/ui-components";
import { useCreateSchedule, useError, useLoader, useSchedule } from "@piiqtechnologies/ui-lib";
import { Form, Formik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { AccessDeviceFormFields, CreateAccessDeviceFormInitialValues, CreateAccessDeviceFormValidationSchema, } from "./CreateAccessDeviceFormConfig";
import messages from "./messages.i18n";
export const CreateAccessDeviceForm = ({ onSubmit, community }) => {
    const intl = useIntl();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const [savedValues, setSavedValues] = useState();
    const [getSchedule, schedule, isFetchingSchedule, errorFetchingSchedules] = useSchedule();
    const [createSchedule, scheduleCreated, isCreatingSchedule, errorCreatingSchedule] = useCreateSchedule();
    const isEmptyObject = useCallback((obj) => {
        if (typeof obj !== "object" || obj === null) {
            return false;
        }
        return Object.keys(obj).length === 0;
    }, []);
    const createNewSchedule = () => {
        createSchedule({
            scheduleEntity: {
                _id: community._id,
                type: "property",
            },
            timeZone: community.timezone,
            tourLength: 30,
            available: true,
            padding: 10,
            availability: [
                { weekday: 0, openTime: 540, closeTime: 1080 },
                { weekday: 1, openTime: 540, closeTime: 1080 },
                { weekday: 2, openTime: 540, closeTime: 1080 },
                { weekday: 3, openTime: 540, closeTime: 1080 },
                { weekday: 4, openTime: 540, closeTime: 1080 },
                { weekday: 5, openTime: 540, closeTime: 1080 },
                { weekday: 6, openTime: 540, closeTime: 1080 },
            ],
        });
    };
    const handleCreateAccessDevice = (values) => {
        if (!schedule || isEmptyObject(schedule)) {
            setSavedValues(values);
            createNewSchedule();
            return;
        }
        onSubmit(values);
    };
    useEffect(() => {
        if (scheduleCreated && savedValues) {
            onSubmit(savedValues);
        }
    }, [scheduleCreated]);
    useEffect(() => {
        community &&
            getSchedule({
                scheduleEntityId: community._id,
            });
    }, [community]);
    useEffect(() => {
        errorFetchingSchedules && setError(errorFetchingSchedules === null || errorFetchingSchedules === void 0 ? void 0 : errorFetchingSchedules.message);
        errorCreatingSchedule && setError(errorCreatingSchedule === null || errorCreatingSchedule === void 0 ? void 0 : errorCreatingSchedule.message);
    }, [errorFetchingSchedules, errorCreatingSchedule]);
    useEffect(() => {
        setLoader(isFetchingSchedule || isCreatingSchedule);
        return () => setLoader(false);
    }, [isFetchingSchedule, isCreatingSchedule]);
    return (React.createElement(Formik, { initialValues: CreateAccessDeviceFormInitialValues, validationSchema: CreateAccessDeviceFormValidationSchema(), onSubmit: handleCreateAccessDevice }, ({ values }) => {
        return (React.createElement(Form, null,
            React.createElement(PeekDialogContent, null,
                React.createElement(MultiColumnFormFields, { fullWidth: true, fields: AccessDeviceFormFields(values.type) })),
            React.createElement(PeekDialogActions, null,
                React.createElement(PeekButton, { size: "large", type: "submit", color: "primary", variant: "contained", fullWidth: true }, intl.formatMessage(messages.createAccessDeviceButtonText)))));
    }));
};
export default CreateAccessDeviceForm;
